import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";

import { iniciarSesion } from "../../app/autenticacion";
import { Boton, Campo, LayoutAuth } from "../../ui";

/** El access se entrega solo a iniciarSesion, que lo conserva en memoria. */
export function PantallaLogin() {
  const navegar = useNavigate();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [mostrar, setMostrar] = useState(false);
  const [error, setError] = useState("");
  const [enviando, setEnviando] = useState(false);

  async function entrar(evento: FormEvent<HTMLFormElement>) {
    evento.preventDefault(); setError(""); setEnviando(true);
    try {
      const respuesta = await fetch("/api/v1/auth/login", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ login, password }) });
      const datos = (await respuesta.json().catch(() => ({}))) as { access?: string; intentos_restantes?: number; yo?: { usuario?: { debe_cambiar_password?: boolean } } };
      if (!respuesta.ok) {
        const intentos = datos.intentos_restantes;
        setError(respuesta.status === 429
          ? "Alcanzaste el límite de intentos. Espera un minuto antes de volver a intentarlo."
          : intentos === 0
            ? "Bloqueamos el acceso por demasiados intentos fallidos. Espera una hora o pide a tu administrador una contraseña temporal."
            : `Usuario o contraseña incorrectos${typeof intentos === "number" ? `. Te quedan ${intentos} intento${intentos === 1 ? "" : "s"}.` : ""}`);
        return;
      }
      if (!datos.access) throw new Error("access ausente");
      iniciarSesion(datos.access);
      navegar(datos.yo?.usuario?.debe_cambiar_password ? "/cuenta/contrasena" : "/inicio", { replace: true });
    } catch { setError("Usuario o contraseña incorrectos"); }
    finally { setEnviando(false); }
  }

  return <LayoutAuth>
    <form className="flex flex-col gap-4" onSubmit={entrar}>
      <div><h1 className="text-titulo-seccion text-texto">Entra a tu cuenta</h1><p className="mt-1 text-nota text-texto-secundario">Usa tu email o usuario para continuar.</p></div>
      <Campo etiqueta="Email o usuario" value={login} onChange={(e) => setLogin(e.target.value)} autoComplete="username" required />
      <div><Campo etiqueta="Contraseña" type={mostrar ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required /><button type="button" className="mt-1 min-h-control text-etiqueta text-primario underline" onClick={() => setMostrar((v) => !v)}>{mostrar ? "Ocultar contraseña" : "Mostrar contraseña"}</button></div>
      {error ? <p role="alert" className="text-nota text-peligro">{error}</p> : null}
      <Boton type="submit" cargando={enviando}>Entrar</Boton>
      <button type="button" className="min-h-control text-etiqueta text-primario underline" onClick={() => navegar("/registro")}>Crear una cuenta</button>
    </form>
  </LayoutAuth>;
}
